import { useEffect } from 'react';
import { Alert, Button, Card, Col, Form, Input, Row, Space, message } from 'antd';
import {
  useCompanyData,
  useSendTelegramTestMessage,
  useUpdateCompanyAlert,
} from '../../../../../../../../Hooks/TT_ELD/Companies';
import { getProviderFromUrl } from '../../../../../../../../Utils/providerURL';
import { useProjectData } from '../../../../../../../../Hooks/useProjectData';

type MyObjectType = {
  [key: string | number]: any;
};

const normalize = (value: any) => {
  if (value === '' || value === undefined || value === null) return null;
  return value;
};

// Sent by the ELD bot when a driver crosses into Washington, Idaho or Oregon
const RedZoneAlertsTab = ({ companyId }: { companyId: any }) => {
  const [form] = Form.useForm();

  const { data, isFetching, isLoading, refetch }: MyObjectType = useCompanyData(companyId);
  const { mutate: updateCompanyAlert, isLoading: isPending } = useUpdateCompanyAlert();
  const { mutate: sendTestMessage, isLoading: isTestPending } = useSendTelegramTestMessage();

  const { projectData } = useProjectData();
  const provider = getProviderFromUrl(projectData.baseUrl);

  useEffect(() => {
    form.setFieldsValue({
      redZoneChatId: data?.redZoneChatId,
    });
  }, [data?.redZoneChatId, form]);

  const onSubmit = (values: any) => {
    const redZoneChatId = normalize(values.redZoneChatId);

    if (normalize(data?.redZoneChatId) === redZoneChatId) {
      message.warning('No changes detected');
      return;
    }

    updateCompanyAlert(
      {
        companyId,
        body: {
          redZoneChatId,
        },
      },
      {
        onSuccess: () => {
          refetch();
        },
      },
    );
  };

  const handleTestMessage = () => {
    const chatId = form.getFieldValue('redZoneChatId');

    if (!chatId) return;

    sendTestMessage({
      chatId,
      botType: 'eld',
      message: 'Success! Your chat has been connected, and Red Zone alerts will now be sent here',
    });
  };

  return (
    <Card loading={isLoading || isFetching} style={{ width: '100%' }}>
      <Form
        form={form}
        layout="vertical"
        onFinish={onSubmit}
        name="red-zone-alerts-form"
        initialValues={{
          redZoneChatId: data?.redZoneChatId,
        }}
      >
        <Row gutter={[16, 10]}>
          <Col xs={24} sm={24} md={16} lg={12}>
            <Alert
              type="info"
              showIcon
              style={{ marginBottom: 16 }}
              message="Alerts when a driver enters Washington (WA), Idaho (ID) or Oregon (OR)"
              description="One alert per state entry. Leave the Chat ID empty to turn the alerts off. The bot must be added to the chat or channel."
            />
          </Col>
        </Row>
        <Row gutter={[16, 10]}>
          <Col xs={24} sm={24} md={12} lg={8}>
            <Form.Item
              label={
                <span>
                  Red Zone Alert Chat ID{' '}
                  <span style={{ color: '#999' }}>{`(Supported bots: @control_${provider}_bot)`}</span>
                </span>
              }
            >
              <Space.Compact style={{ width: '100%' }}>
                <Form.Item noStyle name="redZoneChatId">
                  <Input placeholder="Enter Chat ID" />
                </Form.Item>
                <Button type="primary" loading={isTestPending} onClick={handleTestMessage}>
                  Test Message
                </Button>
              </Space.Compact>
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={isPending}>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default RedZoneAlertsTab;
